module.exports = __webpack_public_path__ + "static/multimedia-ca886203882be6abb2d9031f644929bf.jpg";